import { PUBLIC_PAGE_API_ENDPOINT, DEVELOPMENT_MODE } from "../constants"

export function assetBaseUrl() {
	if (DEVELOPMENT_MODE) {
		return PUBLIC_PAGE_API_ENDPOINT
	} else {
		return ""
	}
}
